import getApiClient from '@/plugins/api'
import fileValidator from '@/helpers/fileValidator'

export default {
  loadAgency() {
    const self = this,
      api = getApiClient(self.$store),
      agencyId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`agencies/${agencyId}`)
      .then(result => {
        result.data.cart = result.data.cart > 0
        if (!result.data.cover) {
          result.data.cover = ''
        }
        self.agency = result.data
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  openCropper(files, model) {
    const self = this
    const image = files[0]

    this.croppingModel = model

    const valid = fileValidator(image, {
      maximumSize: (1024 * 2000)
    })

    if (!valid.result) {
      alert(valid.message)
      return
    }

    const reader = new FileReader()
    reader.readAsDataURL(image)
    reader.onload = e => {
      self.croppingImage = e.target.result
      self.showCropper = true
    }
  },

  closeCropper() {
    this.croppingImage = null
    this.showCropper = false
    this.croppingModel = null
  },

  setImage() {
    const {canvas} = this.$refs.imageCropper.getResult()
    switch (this.croppingModel) {
      case 'picture':
        this.agency.picture = canvas.toDataURL('image/jpeg', 70)
        break;
      case 'cover':
        this.agency.cover = canvas.toDataURL('image/jpeg', 70)
        break;
    }
    this.croppingImage = null
    this.showCropper = false
    this.croppingModel = null
  },

  saveAgency() {
    const self = this,
      api = getApiClient(self.$store),
      agencyId = self.$route.params.id ?? null

    self.$store.commit('startLoading')
    self.error = false
    self.success = false
    self.resetErrors()

    let payload = {...self.agency}
    payload.cart = payload.cart ? 1 : 0
    if (!payload.terms) {
      delete payload.terms
    }

    if (agencyId) {
      api.patch(`agencies/${agencyId}`, payload, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      })
        .then(() => {
          self.loadAgency()
          self.success = true
        })
        .catch(error => {
          switch (error.response.status) {
            case 400:
            case 422:
              self.processValidationErrors(error.response.data)
              break;
            case 500:
              self.error = true
              break;
          }
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })

      return
    }

    api.post(`agencies`, payload)
      .then((result) => {
        self.$router.push({
          name: 'Editar agência',
          params: {
            id: result.data.id
          }
        })
        self.success = true
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
          case 422:
            self.processValidationErrors(error.response.data)
            break;
          case 500:
            self.error = true
            break;
        }
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  setCart(event) {
    this.agency.cart = event.target.checked
  },

  setSplit(event) {
    this.agency.split = event.target.checked
  },

  setUseNativeSplit(event) {
    this.agency.useNativeSplit = event.target.checked
  },

  setStatus(event) {
    this.agency.status = event.target.checked
  },

  processValidationErrors(errors) {
    const self = this
    if (errors.violations) {
      errors.violations.forEach((violation) => {
        self.errors[violation.propertyPath] = violation.message
      })

      self.error = true
    }
  },

  resetErrors() {
    this.errors = {
      name: null,
      cover: null,
      picture: null,
      about: null,
      description: null,
      cart: null,
      recebeAquiToken: null,
      cnpj: null,
      cadastur: null,
      mail: null,
      fbPageId: null,
      phone: null,
      password: null,
      split: null,
      useNativeSplit: null,
    }
  },

  resetAgency() {
    this.agency = {
      name: '',
      picture: '',
      about: '',
      description: '',
      cart: false,
      recebeAquiToken: '',
      cnpj: '',
      cadastur: '',
      mail: '',
      fbPageId: '',
      phone: '',
      password: '',
      split: false,
      useNativeSplit: false,
    }
  },
}
